var aoSpecOccSimplePS = `
uniform float material_occludeSpecularIntensity;

void occludeSpecular() {
		float specOcc = mix(1.0, dAo, material_occludeSpecularIntensity);
		dSpecularLight *= specOcc;
		dReflection *= specOcc;
}
`;

export { aoSpecOccSimplePS as default };
